import {RecordForm} from '../forms/RecordForm';


import {useUser} from '../hooks/useUser';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";


export const AddPage = () => {

    const navigate = useNavigate();

    const {
        record,
        createRecord,
    } = useUser();

    return (
        <FormPageLayout
            title='Add User'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record || {} as any} handleSubmit={createRecord} handleCancel={() => navigate('/users')}/>
        </FormPageLayout>
    );
};
